import React from "react";
import { Badge, Col } from "react-bootstrap";
/**Content Title takes props: position ("left" or "right"), and a Title*/
export const ContentTitle = (props) => {

    const orientation = () => {
        var orientationRet = "d-flex justify-content-start"
        if (props.position !== undefined || props.position !== null) {
            if (props.position === "right") {
                orientationRet = "d-flex justify-content-end";
            }
        }
        return orientationRet;
    }
    return(
            <Col 
                className={orientation()}
                style={{
                    marginTop: "3px"
                    ,marginBottom: "3px"
                }}>
                <div 
                    style={{
                        whiteSpace: 'pre-wrap'
                        ,wordWrap: 'break-word'
                        // ,borderColor: '#b8daff'
                        // ,borderRadius: '10px'
                        // ,backgroundColor: "#cce5ff"
                        ,color: "black"
                        ,paddingLeft: '2px'
                        ,paddingRight: '2px'
                        // ,textAlign: "center"  
                        ,verticalAlign: 'middle'        
                    }}
                ><Badge bg="primary"><h4>{props.title}</h4></Badge></div>
            </Col>
    )
}